module.exports = __webpack_public_path__ + "static/media/kodiakKingdom.1df392f0.png";